@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

<p-dialog header="Voucher Usage History" [(visible)]="showVoucherHistory" [style]="{width: '90vw'}" [baseZIndex]="10000"  [modal]="true">
  <div class="field mb-4 col-12" style="text-align: center;">
    <div style="margin-bottom:20px;text-align: left;margin-top:-10px;"><b>Bold dates indicate original purhcase date</b></div>
    <p-table #voucherTable2
      [value]="voucherList" [sortOrder]="-1" [paginator]="true" [rows]="10"
      [showCurrentPageReport]="true" responsiveLayout="scroll"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      [rowsPerPageOptions]="[10,25,50]"
      [globalFilterFields]="['vouchercode','customername']"
      [(selection)]="selectedItems"
      responsiveLayout="scroll"
      datakey="id"
      [selectionPageOnly]="true">
      <ng-template #header>
        <tr>
          <th pSortableColumn="vouchercode" width="15%">Code
            <p-sorticon [field]="vouchercode"></p-sorticon>
          </th>
          <th pSortableColumn="created" width="15%">Date
            <p-sorticon [field]="created"></p-sorticon>
          </th>
          <th pSortableColumn="expiry" width="10%">Expiry Date
            <p-sorticon [field]="expiry"></p-sorticon>
          </th>
          <th pSortableColumn="customername" width="24%">Customer Name
            <p-sorticon [field]="customername"></p-sorticon>
          </th>
          <th pSortableColumn="balance" width="10%">Value
            <p-sorticon [field]="balance"></p-sorticon>
          </th>
          <th pSortableColumn="balance" width="15%">Booking ID
            <p-sorticon [field]="bookingidhr"></p-sorticon>
          </th>
          <th>
            &nbsp;
          </th>
        </tr>
      </ng-template>

      <ng-template #body let-data>
        @if (data.ischild && data.value > 0) {
          <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
            <td style="color:red">{{data.vouchercode}}</td>
            <td style="color:red">{{data.created | date:'dd/MM/yy'}}</td>
            <td style="color:red">{{data.expiry | date:'dd/MM/yy'}}</td>
            <td style="color:red">{{data.customername}}</td>
            <td style="color:red">{{data.value | currency: CurrencySymbol}}</td>
            <td style="color:red">{{data.bookingidhr}}</td>
            <td>
              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" (click)="viewBooking(data.bookingid, data.voucherid)">
                <span class="pi pi-eye" style="margin-right:8px;"></span>
                <span i18>View</span>
              </button>
            </td>
          </tr>
        }

        @if (!data.ischild  && data.value < 0) {
          <tr  [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
            <td>{{data.vouchercode}}</td>
            <td>{{data.created | date:'dd/MM/yy'}}</td>
            <td>{{data.expiry | date:'dd/MM/yy'}}</td>
            <td>{{data.customername}}</td>
            <td>{{data.value | currency: CurrencySymbol}}</td>
            <td>{{data.bookingidhr}}</td>
            <td>
              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" (click)="viewBooking(data.bookingid, data.voucherid)">
                <span class="pi pi-eye" style="margin-right:8px;"></span>
                <span i18>View</span>
              </button>
            </td>
          </tr>
        }

        @if (!data.ischild  && data.value > 0) {
          <tr  [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
            <td>{{data.vouchercode}}</td>
            <td><b>{{data.created | date:'dd/MM/yy'}}</b></td>
            <td>{{data.expiry | date:'dd/MM/yy'}}</td>
            <td>{{data.customername}}</td>
            <td>{{data.value | currency: CurrencySymbol}}</td>
            <td>{{data.bookingidhr}}</td>
            <td>
              <button pButton type="button" disabled="true" class="p-button-sm p-element p-ripple p-button-info p-button p-component" (click)="viewBooking(data.bookingid, data.voucherid)">
                <span class="pi pi-eye" style="margin-right:8px;"></span>
                <span i18>View</span>
              </button>
            </td>
          </tr>
        }

        @if (data.ischild  && data.value < 0) {
          <tr  [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
            <td>{{data.vouchercode}}</td>
            <td>{{data.created | date:'dd/MM/yy'}}</td>
            <td>{{data.expiry | date:'dd/MM/yy'}}</td>
            <td>{{data.customername}}</td>
            <td>{{data.value | currency: CurrencySymbol}}</td>
            <td>{{data.bookingidhr}}</td>
            <td>
              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" (click)="viewBooking(data.bookingid, data.voucherid)">
                <span class="pi pi-eye" style="margin-right:8px;"></span>
                <span i18>View</span>
              </button>
            </td>
          </tr>
        }
      </ng-template>
    </p-table>

    <div style="margin-top:20px;text-align: left;font-size:20px;"><b>Current Balance: {{CurrentVoucherValue | currency: CurrencySymbol}}</b></div>

  </div>
  <ng-template #footer>
    <p-button icon="pi pi-times" label="Close" styleClass="p-button p-button-success" (click)="close()"></p-button>
  </ng-template>
</p-dialog>

@if (ListVouchers
  && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Vouchers
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
    </p>
    <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
      <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'height': '50px'}" (click)="toggleDisabled()">
      </p-togglebutton>
      <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="voucherTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Voucher Name"/>
      </span>
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span i18>Disable</span>
      </button>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table #voucherTable
        [value]="ListVouchers" [sort]="created" [sortOrder]="-1" [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true" responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        [globalFilterFields]="['vouchercode','customername']"
        [(selection)]="selectedItems"
        responsiveLayout="scroll"
        datakey="id"
        [selectionPageOnly]="true">
        <ng-template #header>
          <tr>
            <th width="1%">
              <p-tableheadercheckbox></p-tableheadercheckbox>
            </th>
            <th pSortableColumn="vouchercode" width="15%">Code
              <p-sorticon [field]="vouchercode"></p-sorticon>
            </th>
            <th pSortableColumn="created" width="15%">Purchase Date
              <p-sorticon [field]="created"></p-sorticon>
            </th>
            <th pSortableColumn="expiry" width="10%">Expiry Date
              <p-sorticon [field]="expiry"></p-sorticon>
            </th>
            <th pSortableColumn="customername" width="29%">Customer Name
              <p-sorticon [field]="customername"></p-sorticon>
            </th>
            <th pSortableColumn="balance" width="10%">Value
              <p-sorticon [field]="value"></p-sorticon>
            </th>
            <th pSortableColumn="balance" width="10%">No Payment Reason
              <p-sorticon [field]="defernotes"></p-sorticon>
            </th>
            <th width="5%"></th>
            <th width="5%"></th>
            <th width="5%"></th>
            <th width="10%"></th>
          </tr>
        </ng-template>
        <ng-template #body let-data>
          <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
            <td>
              <p-tablecheckbox [value]="data"></p-tablecheckbox>
            </td>
            <td>{{data.vouchercode}}</td>
            <td>{{data.created | date:'dd/MM/yy'}}</td>
            <td>{{data.expiry | date:'dd/MM/yy'}}</td>
            <td>{{data.customername}}</td>
            <td>{{data.value | currency: CurrencySymbol}}</td>
            <td>{{data.defernotes}}</td>
            @if (!data.isexpired) {
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;" (click)="editData(data.voucherid);" i18>
                <span class="pi pi-pencil" style="margin-right:8px;"></span>
                <span i18n>Edit</span>
              </button></td>
            }
            @if (data.isexpired) {
              <td><button pButton disabled="true" type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;" (click)="editData(data.voucherid);" i18>
                <span class="pi pi-pencil" style="margin-right:8px;"></span>
                <span i18n>Edit</span>
              </button></td>
            }
            @if (!data.isexpired) {
              <td><button  pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableData(data.voucherid)" i18>
                <span class="pi pi-trash" style="margin-right:8px;"></span>
                <span i18n>Disable</span>
              </button></td>
            }
            @if (data.isexpired) {
              <td ><button pButton type="button" disabled="true" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableData(data.voucherid)" i18>
                <span class="pi pi-trash" style="margin-right:8px;"></span>
                <span i18n>Disable</span>
              </button></td>
            }
            @if (!data.isexpired) {
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="margin-left:-20px;"  (click)="sendEmailConfirmationById(data.voucherid)" i18>
                <span class="pi pi-send" style="margin-right:8px;"></span>
                <span i18n>Resend</span>
              </button></td>
            }
            @if (data.isexpired) {
              <td><button pButton type="button" disabled="true" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="margin-left:-20px;"  (click)="sendEmailConfirmationById(data.voucherid)" i18>
                <span class="pi pi-send" style="margin-right:8px;"></span>
                <span i18n>Resend</span>
              </button></td>
            }
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="margin-left:-20px; width:160px;"  (click)="showHistory(data.voucherid)" i18>
              <span class="pi pi-history" style="margin-right:8px;"></span>
              <span i18n>Usage History</span>
            </button></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
